import { ScoopInfoTooltip, ScoopText } from '../../../../../../ui'
import styles from './FormField.module.scss'

/**
 * FormField - Wrapper for form fields with label and optional help tooltip
 *
 * @param {string} label - Field label
 * @param {string} helpText - Optional help text shown in tooltip
 * @param {React.ReactNode} children - Form input/control
 * @param {boolean} required - Whether field is required
 * @param {string} error - Error message
 * @param {string} className - Additional CSS classes
 * @param {boolean} inline - Display label and field inline
 */
export const FormField = ({
    label,
    helpText,
    children,
    required = false,
    error,
    className = '',
    inline = false,
}) => {
    return (
        <div className={`${styles.field} ${inline ? styles.inline : ''} ${className}`}>
            {label && (
                <div className={styles.labelRow}>
                    <ScoopText as="label" className={styles.label}>
                        {label}
                        {required && (
                            <ScoopText as="span" className={styles.required}>
                                *
                            </ScoopText>
                        )}
                    </ScoopText>
                    {helpText && <ScoopInfoTooltip title={helpText} placement="top" />}
                </div>
            )}
            <div className={styles.inputWrapper}>{children}</div>
            {error && <ScoopText className={styles.error}>{error}</ScoopText>}
        </div>
    )
}
